import React from 'react';
import './PipelineDiagram.css';

/**
 * Pure CSS/flexbox horizontal pipeline diagram. Renders `steps` as rounded
 * node boxes joined by arrows; wraps to a vertical stack on narrow screens.
 */
const PipelineDiagram = ({ steps = [] }) => {
  if (!steps.length) return null;

  return (
    <div className="pipeline-diagram" role="list" aria-label="Data pipeline steps">
      {steps.map((step, idx) => (
        <React.Fragment key={step}>
          <div className="pipeline-node" role="listitem">
            {step}
          </div>
          {idx < steps.length - 1 && (
            <div className="pipeline-arrow" aria-hidden="true">
              <span className="pipeline-arrow-horizontal">&#8594;</span>
              <span className="pipeline-arrow-vertical">&#8595;</span>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default PipelineDiagram;
